.container {
  display: flex;
  flex-direction: column;
  gap: 1.6rem;
  width: 100%;
}

.field-container {
  margin-bottom: 2.2rem;
  display: flex;
  flex-direction: column;
  gap: 0.8rem;

  div[side='top'] {
    margin-left: 5rem;
  }
}

.settings-form {
  max-width: 64.8rem;
  padding-bottom: 1.8rem;
  border-bottom: 0.1rem solid var(--color-grey-7-5);
}

.button-wrapper {
  max-width: 64.8rem;
  margin-top: 0.8rem;
  display: flex;
  justify-content: end;
  min-height: 4rem;
}
